<template>
  <section>
    <v-card
      elevation="0"
      color="#E2E2E2"
    >
      <v-card-title>
        <p class="process-header">
          Review Details
        </p>
      </v-card-title>
      <v-card-text>
        <p class="title-text-style">
          Project: <font class="value-text-style">
            {{ selectedWorkDetails.details.project.name }}
          </font>
        </p>
        <p class="title-text-style">
          Check-in Gate: <font class="value-text-style">
            {{ locationName.name }}
          </font>
        </p>
        <p class="title-text-style">
          Name: <font
            v-if="selectedWorkDetails.workType === 'project-work'"
            class="value-text-style"
          >
            {{ selectedWorkDetails.details.name }}
          </font>
          <font
            v-else
            class="value-text-style"
          >
            {{ selectedWorkDetails.details.title }}
          </font>
        </p>
        <p class="title-text-style">
          Type: <font class="value-text-style">
            {{ selectedWorkDetails.workType | workTypeFormat }}
          </font>
        </p>
        <p class="title-text-style">
          Description: <font
            v-if="selectedWorkDetails.details.description !== null"
            class="value-text-style"
          >
            {{ selectedWorkDetails.details.description }}
          </font>
          <font
            v-else
            class="value-text-style"
          >
            N/A
          </font>
        </p>
        <p class="title-text-style">
          High Risk Work: <font :color="getHrwColor(selectedWorkDetails.details.high_risk_work)">
            {{ selectedWorkDetails.details.high_risk_work | displayHighRisk }}
          </font>
        </p>
      </v-card-text>
    </v-card>
    <v-btn
      v-if="activeCheckInDetails.work_details.budget"
      color="#37474F"
      class="mt-5 btn-style"
      elevation="0"
      @click="costShift()"
    >
      Cost Shift
    </v-btn>
    <v-btn
      v-else
      color="#37474F"
      class="mt-5 btn-style"
      elevation="0"
      @click="openCurrentIssueStatusPopup()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
    <gather-issue-status
      v-if="showIssueStatusPage"
      :active-check-in-details="activeCheckInDetails"
      @cost-shift="costShift"
    />
  </section>
</template>
  <script>
    import spinner from 'src/views/components/SpinnerCentre';
    import Constants from 'src/constants';
    import moment from 'moment';
    import GatherIssueStatus from './GatherIssueStatus.vue';

    export default {
      name: 'ReviewWorkDetails',
      components: {
        'centre-spinner': spinner,
        'gather-issue-status': GatherIssueStatus,
      },
      filters: {
        displayHighRisk (status) {
          if (status === true) {
            return 'Yes*';
          } else {
            return 'No';
          }
        },
        workTypeFormat (val) {
          if (val === 'project-work') {
            return 'Project Work';
          } else {
            return 'Project Issue';
          }
        },
      },
      data: () => ({
        loading: false,
        checkInType: 'Worker',
        showIssueStatusPage: false,
      }),
      computed: {
        selectedWorkDetails () {
          return this.$store.getters['swiftuser/getSelectedWorkDetails'];
        },
        selectedAnswers () {
          return this.$store.getters['questions/getUserSelectedAnswers'];
        },
        checkInId () {
          return this.$store.getters['swiftuser/getCheckInId'];
        },
        locationName () {
          return this.$store.getters['swiftuser/getLocationName'];
        },
        selectedInstanceDetails () {
          return this.$store.getters['swiftuser/getSelectedInstanceDetails'];
        },
        checkInMethodType () {
          return this.$store.getters['swiftuser/getCheckInMethodType'];
        },
        selectedOrganization () {
          return this.$store.getters['organization/getSelectedOrganization'];
        },
        activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      },
      methods: {
        openCurrentIssueStatusPopup () {
            this.showIssueStatusPage = true;
        },
        costShift () {
          this.Currentcheckout();
          this.loading = true;
          this.$store.dispatch('swiftuser/checkInUser', {
            orgExtId: this.activeCheckInDetails.organization_id,
          details: {
            checkin_time: moment.utc().format(),
            location_id: null,
            type: 'worker',
            checkin_method_type: 'cost-shift',
            project_id: this.selectedWorkDetails.details.project.id,
          },
          }).then(response => {
            this.completeCheckInProcess();
          }).catch(errors => {
            this.loading = false;
          });
        },
        Currentcheckout () {
        this.$store.dispatch('swiftuser/checkOutUser', {
          checkOutTime: {
            checkout_time: moment.utc().format(),
            type: 'cost-shift',
            manual_checkout_reason: null,
            checkout_gate: null,
            latitude: null,
            longitude: null,
          },
          checkInId: this.activeCheckInDetails.id,
        }).then(response => {
          this.loading = false;
          this.$emit('cost-shift');
          this.$emit('checkout-completed');
        }).catch(errors => {
          this.loading = false;
        });
      },
        async completeCheckInProcess () {
          const selectedAnswers = [];
          selectedAnswers.push({
            answers: this.selectedAnswers,
          });
          await this.$store.dispatch('questions/sendUserSelectedAnswers', {
            answers: selectedAnswers[0],
            checkInId: this.checkInId.id,
          }).then(response => {
            this.sendWorkDetails();
          }).catch(() => {
            this.loading = false;
          });
        },
        async sendWorkDetails () {
          if (this.selectedWorkDetails.workType === 'project-work') {
            await this.$store.dispatch('swiftuser/sendWorkDetails', {
              details: {
                budget_id: this.selectedWorkDetails.details.id,
                budget_instance_id: this.selectedInstanceDetails,
                issue_id: null,
                type: 'project-work',
              },
              checkInId: this.checkInId.id,
            }).then(response => {
              this.loading = false;
              this.$emit('checkin-completed');
            }).catch(() => {
              this.loading = false;
            });
          return;
          }

          await this.$store.dispatch('swiftuser/sendWorkDetails', {
            details: {
              budget_id: null,
              budget_instance_id: null,
              issue_id: this.selectedWorkDetails.details.id,
              type: 'project-issue',
            },
            checkInId: this.checkInId.id,
          }).then(response => {
            this.loading = false;
            this.$store.dispatch('alert/onAlert', {
              message: 'Check-in completed successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.$emit('checkin-completed');
          }).catch(() => {
            this.loading = false;
          });
        },
        cancel () {
          this.loading = true;
          localStorage.removeItem('siteId');
          localStorage.removeItem('scannedTime');
          setTimeout(() => {
            this.$router.push({ name: 'CheckIn' });
          }, 1000);
        },
        getHrwColor (value) {
          if (value === true) return '#C62828';
          else { return '#2E7D32'; }
        },
      },
    };
  </script>
